<template>
  <div id="app">
    <!-- loading -->
    <div class="loading d-flex justify-content-center" v-if="isLoading">
      <vueSpinner class="align-self-center"></vueSpinner>
    </div>

    <!-- message -->
    <modal class="systemModal"
      :top="true"
      :styleObject="{ 'width': '60vh' }"
      @close="doLogout"
      v-if="errorMessage !== ''">
      <div slot="header">{{ $t('message') }}</div>
      <div slot="body">
        <!-- {{ locale==='tw'?errorMessage.split('。')[0]:errorMessage.split('。')[1] }} -->
        {{ $t(errorMessage) ? $t(errorMessage) : errorMessage }}
      </div>
      <div slot="footer">
        <button class="btn btn-primary" @click="doLogout">{{ $t('yes') }}</button>
      </div>
    </modal>

    <!-- Fixed navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top border-primary p-0"
      ref="navbar"
      :style="{ 'border-bottom': '5px solid' }"
      v-if="$route.path !== '/' && $route.path !== '/login'">
      <div class="container" style="max-width: 100%!important;">
        <div class="w-25 ml-5">
          <ul class="nav navbar-nav">
            <button class="btn btn-xs menu-icon" v-on:click="toggleMenu()" :style="{ 'background-color': 'transparent' }">
              <transition
                enter-active-class="animated fadeIn slower"
                leave-active-class="animated rotateOut faster">
                <img src="~./assets/image/icon/menu.png" height="50" v-if="!showMenu" />
              </transition>

              <transition
                enter-active-class="animated fadeIn slower"
                leave-active-class="animated rotateOut faster">
                <img src="~./assets/image/icon/down_arrow.png" height="50" v-if="showMenu">
              </transition>
            </button>
          </ul>
        </div>

        <router-link class="d-none d-md-block" :to="{ name: user ? 'home' : 'login' }"
          v-bind:class="{ 'navbar-brand': true, 'mx-auto': $route.path !== '/' } ">
          <img src="~./assets/image/logo_L_size.png" height="50" />
        </router-link>

        <div class="w-25 d-flex justify-content-end mr-5" id="navbarToggler1">
          <ul class="navbar-nav ml-auto">
            <!-- Authenticated -->
            <li v-if="user" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle text-dark" @click="toggleUserMenu()" data-toggle="dropdown">
                <span class="displayUserName" :style="{
                  'letter-spacing': '3px'
                }">Hi, {{ user.realname }}</span>
                <img :src="user.photo_url" class="rounded-circle profile-photo mr-1" height="50" v-if="user.photo_url">
                <img src="~./assets/image/icon/btn_user.png" class="rounded-circle profile-photo mr-1" height="50" v-if="!user.photo_url && user.rolename !== 'Teacher'">
                <img src="~./assets/image/icon/btn_teacher.png" class="rounded-circle profile-photo mr-1" height="50" v-if="!user.photo_url && user.rolename === 'Teacher'">
              </a>

              <div class="dropdown-menu" v-if="false">
                <div class="dropdown-divider"></div>

                <router-link class="dropdown-item pl-3" :to="'/user/logout'">
                  {{ $t('logout') }}
                </router-link>
              </div>
            </li>

            <li class="nav-item" :style="{ 'background-color': '#e1bc26', 'width': '200px', 'text-align': 'center' }" v-else>
              <a class="nav-link" active-class="active" :style="{ 'color': '#fff' }"
                @click="$modal.show('login-modal')">{{ $t('login') }} / {{ $t('register') }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div id="menu-layout" class="w-100 animated fadeIn" v-if="showMenu || showUserMenu" @click.prevent.stop="showUserMenu = false; showMenu = false">
        <div class="menu col-12 col-md-3" v-if="showMenu" @click.prevent.stop="() => { return false }">
          <ul class="nav flex-column nav-pills">
            <li v-for="(item, key) in menu" class="nav-item" @click="showMenu = false">
              <router-link :to="'/' + key"
                style="justify -content: left;"
                class="nav-link">
                {{ $t(item.name) }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="menu menu-right col-12 col-md-3" v-if="showUserMenu" @click.prevent.stop="() => { return false }">
          <ul class="nav flex-column nav-pills">
            <!-- <li class="nav-item" @click="showUserMenu = false"> -->
              <!-- <router-link class="nav-link" :to="'/user/password'"> -->
                <!-- 修改密碼 -->
                <!-- {{ $t('edit_password') }} -->
              <!-- </router-link> -->
            <!-- </li> -->
            <li class="nav-item" @click="showUserMenu = false">
              <router-link class="nav-link" :to="'/user/logout'">
                {{ $t('logout') }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Begin page content -->
    <router-view style="min-height: calc(100vh - 240px)"></router-view>

    <footer class="pb-3 pt-3">
      <div class="container">
        <div class="row pt-3 pb-3">
          <div class="d-none d-md-block col-md-5"><hr></div>
          <div class="footer-title col-12 col-md-2 text-center">{{ $t('customer_support') }}</div>
          <div class="d-none d-md-block col-md-5"><hr></div>
        </div>
        <div v-if="locale === 'tw'">
          <div class="text-center">
            校園電話：2578-2626 分機282｜校園信箱：guan_chen@liveabc.com
          </div>
          <div class="text-center">
            補習班電話：(02)7730-9567｜補習班信箱： school@liveabc.com
          </div>
          <div class="text-center">
            客服時間：週一至週五 09:00~18:00
          </div>
        </div>
        <div v-else>
          If you have any questions, please contact your local distributor. Thank you.
        </div>
        <div class="text-center">
          Copyright Hebron Soft Limited. All Rights Reserved.
          <a class="btn btn-sm btn-light link" style="text-decoration: underline;" target="_blank" href="https://campus.liveabc.com/Backend">
            LiveABC Product Management
          </a>
        </div>
        <select v-model="locale" @change="setLocale(locale)">
          <option value="en">English</option>
          <option value="tw">繁體中文</option>
        </select>
      </div>
    </footer>
  </div>
</template>

<script>
  import menu from './menu.js'
  import { mapGetters, mapMutations } from 'vuex'
  import vueSpinner from 'vue-spinner/src/ClipLoader.vue'
  import modal from './components/modal'
  import jquery from 'jquery'
  import { apiPath } from './store/api'
  import 'animate.css'

  export default {
    name: 'app',

    components: {
      vueSpinner,
      modal
    },

    data () {
      return {
        showMenu: false,
        showUserMenu: false,
        appPath: apiPath + '/APP.apk',
        locale: window.localStorage.getItem('locale')
      }
    },

    computed: {
      ...mapGetters([
        'isLoading',
        'errorMessage',
        'authorized'
      ]),

      menu () {
        if (this.$store.state.auth.authorized) {
          let newMenu = menu[this.$store.state.auth.userRole]

          if (this.$store.state.auth.user.products) {
            for (let item in menu.Authorization) {
              this.$store.state.auth.user.products.map((el) => {
                if (el === item) {
                  newMenu[el] = menu.Authorization[el]
                }
              })
            }
          }

          return Object.assign(newMenu, menu.common)
        } else {
          return menu.common
        }
      },

      user () {
        return this.$store.state.auth.user
      }
    },
    mounted () {
      let newMenu = {}

      if (this.$store.state.auth.user.products) {
        for (let item in menu.Authorization) {
          this.$store.state.auth.user.products.map((el) => {
            if (el === item) {
              newMenu[el] = menu.Authorization[el]
            }
          })
        }
      }
    },
    methods: {
      ...mapMutations([
        'setErrorMessage'
      ]),

      go (path) {
        jquery('.collapse').collapse('toggle')
        this.$router.push(path)
      },

      toggleMenu () {
        this.showUserMenu = false
        this.showMenu = !this.showMenu
      },

      toggleUserMenu () {
        this.showMenu = false
        this.showUserMenu = !this.showUserMenu
      },

      doLogout () {
        if (this.$store.state.errorMessage === 'already_logout') {
          this.$store.dispatch('logout')
          .then(() => {
            this.setErrorMessage('')
            this.$router.push('/login')
          })
        } else {
          this.setErrorMessage('')
        }
      },
      setLocale (locale) {
        window.localStorage.setItem('locale', locale)
        this.locale = locale
        return window.history.go(0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './assets/style/color.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    // margin-top: 60px;
    background-color: $bg-color;
  }

  .navbar {
    border-radius: 0;
  }

  #header {
    background-color: $bg-green-color !important;
    border-bottom: 1px solid #e2e2e2;

    .nav-link {
      color: white;
    }
  }

  nav {
    border-color: $main-light-color!important;
  }

  footer {
    background-color: #f5f7f6;
    color: #000;
    line-height: 200%;
    font-size: 16px;
    min-height: 162px;

    hr {
      border-color: #000;
    }

    .footer-title {
      width: 150px;
      font-weight: 900;
      letter-spacing: 3px;
    }
  }

  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10000;
    color: white;
  }

  .nav-link {
    cursor: pointer;
  }

  .systemModal {
    z-index: 10000;
  }

  #menu-layout {
    position: fixed;
    top: 69px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    transition: width 0.2s, opacity 0.4s;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999999;

    .menu {
      width: 260px;
      height: 100%;
      background-color: #fff;
      padding: 2em;
      overflow-y: scroll;

      .nav-link {
        line-height: 400%;
      }
    }

    .menu-right {
      position: absolute;
      right: 0;
    }

    .nav-item {
      background-color: transparent;
      line-height: 200%;
      border-bottom: 1px solid gray;
      text-align: center;

      .nav-link {
        color: gray;
        word-spacing: 15px;
        letter-spacing: 3px;
      }
    }
  }

  .menu-icon {
    position: relative;

    &:focus {
      box-shadow: none;
    }

    img {
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  @media screen and (max-width: 768px) {
    footer {
      height: auto;
      min-height: 162px;
    }

    .displayUserName {
      display: none;
    }

    .menu-right {
      position: relative!important;
    }

    .menu {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?208b6640